import { ChartEnum } from "../models/company.model";
import { useConfig } from "../containers/ConfigContext";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import CheckVisibleChart from "../containers/CheckVisibleChart";
import DetailsReportDoughnut from "../components/Charts/DetailsReportDoughnut";
import DetailsHorizontalBar from "../components/Charts/DetailsHorizontalBar";
import DetailsCardList from "../components/Charts/DetailsCardList";
import {
  getCustomersEBTotal,
  getDemonstratedSoldGave,
  getEaseStockKnowledgeVisibleConditionOrangisedDoughnut,
  getProductPromotionalPresence,
  getVapeColleagueProductPromote,
  getVapeProductColleagueKnowledge,
  getVapeProductPromotional,
  getVapeSharedShelf,
  getVapeTakenUp,
  vapeTypes,
} from "../chart-helpers/chart-data";
import { numberFormat } from "../lib/format";
import { blue_chart_color } from "../lib/theme";
import ProductPromotionalPresenceBar from "../components/Charts/ProductPromotionalPresenceBar";

export default function DetailsReportPage() {
  const { loggedUser, data: item, localized } = useConfig();
  if (loggedUser?.company?.charts) {
    loggedUser.company.charts = [
      ...loggedUser.company.charts,
      { key: ChartEnum.doughnut_8, label: "People", visible: true },
      { key: ChartEnum.doughnut_9, label: "Product", visible: true },
      { key: ChartEnum.doughnut_10, label: "Place", visible: true },
      { key: ChartEnum.bar_8, visible: true },
      { key: ChartEnum.bar_9, visible: true },
      { key: ChartEnum.bar_10, visible: true },
      { key: ChartEnum.comments_2, visible: true },
      { key: ChartEnum.cards_2, visible: true },
    ];
  }

  return (
    <Box>
      <Grid container spacing={4}>
        <CheckVisibleChart name={ChartEnum.doughnut_8}>
          <Grid item xs={12} md={4}>
            <ProductPromotionalPresenceBar
              title={localized("Vape Product Colleague Promote")}
              data={getVapeColleagueProductPromote(item)}
            />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.doughnut_8}>
          <Grid item xs={12} md={4}>
            <DetailsReportDoughnut {...getVapeTakenUp(item)} />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.doughnut_8}>
          <Grid item xs={12} md={4}>
            <ProductPromotionalPresenceBar
              title={localized("Vape Shared Shelf")}
              data={getVapeSharedShelf(item)}
            />
          </Grid>
        </CheckVisibleChart>
        {vapeTypes.map((k) => (
          <CheckVisibleChart name={ChartEnum.doughnut_8}>
            <Grid item xs={12} md={4}>
              <DetailsReportDoughnut
                {...getEaseStockKnowledgeVisibleConditionOrangisedDoughnut(
                  k,
                  item,
                )}
              />
            </Grid>
          </CheckVisibleChart>
        ))}
        <CheckVisibleChart name={ChartEnum.bar_8}>
          <Grid item xs={12} md={4}>
            <DetailsHorizontalBar
              title={localized("Demonstrated")}
              items={getDemonstratedSoldGave("demonstrated", item)}
            />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.bar_9}>
          <Grid item xs={12} md={4}>
            <DetailsHorizontalBar
              title={localized("Sold")}
              items={getDemonstratedSoldGave("sold", item)}
            />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.bar_8}>
          <Grid item xs={12} md={4}>
            <DetailsHorizontalBar
              title={localized("Gave")}
              items={getDemonstratedSoldGave("gave", item)}
            />
          </Grid>
        </CheckVisibleChart>

        <CheckVisibleChart name={ChartEnum.cards_2}>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ py: 2 }}>
              <Stack
                className="height-100p"
                direction="column"
                justifyContent="space-around"
                alignItems="center"
              >
                <Typography variant="h5" sx={{ mt: 2 }}>
                  Total
                </Typography>
                <div
                  className="all-center-wrapper"
                  style={{
                    height: 100,
                    width: "80%",
                    backgroundColor: blue_chart_color,
                    bottom: 20,
                    fontSize: 32,
                    color: "white",
                  }}
                >
                  {numberFormat(getCustomersEBTotal(item), 0)}
                </div>
              </Stack>
            </Paper>
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.cards_2}>
          <Grid item xs={12} md={4}>
            <ProductPromotionalPresenceBar
              title={localized("Vape Price Promotion")}
              data={getVapeProductPromotional(item)}
            />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.cards_2}>
          <Grid item xs={12} md={4}>
            <ProductPromotionalPresenceBar
              title={localized("Vape Colleague Knowledge")}
              data={getVapeProductColleagueKnowledge(item)}
            />
          </Grid>
        </CheckVisibleChart>
        <CheckVisibleChart name={ChartEnum.cards_2}>
          <Grid item xs={12}>
            <DetailsCardList title={localized("Promo Offer")} />
          </Grid>
        </CheckVisibleChart>
      </Grid>
    </Box>
  );
}
